const myDocument = {
  newFolderMenuitem: "mydocument-newfolder-menu-item",
  folderVariablesMenuitem: "mydocument-foldervariable-menu-item",
  folderVariableNewIdInputField: "mydocument-folder-variable-new-id-input-field",
  folderVariableNewValueInputField: "mydocument-folder-variable-new-value-input-field",
  folderVariableIdDeleteIconButton: "mydocument-folder-variable-id-delete-icon-button",
  folderVariableIdRollbackIconButton: "mydocument-folder-variable-id-rollback-icon-button",
  folderVariablesManageDialog: "mydocument-folder-variables-manage-dialog",

  folderRenameInputField: "mydocument-folder-rename-input-field",

  sharingSettingsDialog: "mydocument-sharing-settings-dialog",
  auditTrailHistoryDialog: "mydocument-audit-trail-dialog",
  moveResourceDialog: "mydocument-move-resource-dialog",
  moveFolderConfirmDialog: "mydocument-move-folder-confirm-dialog",
};

const eSign = {
  requestOuterFormBtn: "esign-request-outer-form-btn",
  requestFormSubmitBtn: "esign-request-form-submit-btn",

  signatureMarker: "esign-signature-marker",
  dateFormatMarker: "esign-dateformat-marker",
  nameMarker: "esign-name-marker",

  namePlugIconButton: "esign-name-plug-icon-button",
  signaturePlugIconBtn: "esign-signature-plug-icon-btn",
  signDatePlugIconButton: "esign-signdate-plug-icon-button",

  signDeclinedStatusChip: "esign-declined-status-chip",
  signingCompletedStatusRow: "esign-signingcompleted-status-row",
  waitForSigningStatusRow: "esign-waitforsigning-status-row",

  signPadDialog: "esign-signpad-dialog",
  cancelEsignRequestDialog: "esign-cancel-request-dialog",
  declineRequestDialog: "esign-decline-request-dialog",

  myDocumentUploadPdfMenuitem: "esign-mydocuments-upload-pdf-menu-item",
  gxpSigningReasonDropdown: "esign-signing-reason-dropdown",
};

const eConsent = {
  addDropdownNewFolder: "econsent-add-dropdown-item-new-folder",
  addDropdownCreateIcf: "econsent-add-dropdown-item-create-icf",

  createIcfDialog: "econsent-create-icf-dialog",
  createIcfConfirmDialog: "econsent-create-icf-confirm-dialog",
  createFolderDialog: "econsent-create-folder-dialog",
  addSingleSubjectDialog: "econsent-add-single-subject-dialog",
  addMultipleSubjectDialog: "econsent-add-multiple-subject-dialog",

  createIcfDonorNamePlugIconBtn: "econsent-create-icf-donor-name-plug-icon-btn",
  createIcfDonorSignaturePlugIconBtn: "econsent-create-icf-donor-signature-plug-icon-btn",
  createIcfDonorDatePlugIconBtn: "econsent-create-icf-donor-date-plug-icon-btn",
  createIcfDonorEmailPlugIconBtn: "econsent-create-icf-donor-email-plug-icon-btn",
  createIcfDonorSignatureTemplatePlugIconBtn: "econsent-create-icf-donor-signature-template-plug-icon-btn",
  createIcfAddSignatureTemplateDialog: "econsent-create-icf-add-signature-template-dialog",

  createIcfInputItemTextPlugIconBtn: "econsent-create-icf-input-item-text-plug-icon-btn",
  createIcfInputItemDatePlugIconBtn: "econsent-create-icf-input-item-date-plug-icon-btn",
  createIcfInputItemDropdownPlugIconBtn: "econsent-create-icf-input-item-dropdown-plug-icon-btn",
  createIcfInputItemSingleResponsivePlugIconBtn: "econsent-create-icf-input-item-single-responsive-plug-icon-btn",
  createIcfInputItemMultiResponsivePlugIconBtn: "econsent-create-icf-input-item-multi-responsive-plug-icon-btn",
  createIcfInputItemAddressPlugIconBtn: "econsent-create-icf-input-item-address-plug-icon-btn",
  createIcfInputItemFollowWritingPlugIconBtn: "econsent-create-icf-input-item-follow-writing-plug-icon-btn",

  createIcfAdditionalSignerActivePlugIconBtn: "econsent-create-icf-additional-signer-active-plug-icon-btn",
  createIcfAdditionalSignerSignaturePlugIconBtn: "econsent-create-icf-additional-signer-signature-plug-icon-btn",

  createIcfInvestigatorNamePlugIconBtn: "econsent-create-icf-investigator-name-plug-icon-btn",
  createIcfInvestigatorSignaturePlugIconBtn: "econsent-create-icf-investigator-signature-plug-icon-btn",
  createIcfInvestigatorDatePlugIconBtn: "econsent-create-icf-investigator-date-plug-icon-btn",
  createIcfInvestigatorSignatureTemplatePlugIconBtn: "econsent-create-icf-investigator-signature-template-plug-icon-btn",
  createIcfInvestigatorEmailPlugIconBtn: "econsent-create-icf-investigator-email-plug-icon-btn",
  createIcfInvestigatorTitlePlugIconBtn: "econsent-create-icf-investigator-title-plug-icon-btn",
  createIcfInvestigatorCompanyPlugIconBtn: "econsent-create-icf-investigator-company-plug-icon-btn",
};

const common = {
  organizationDropdown: "common-organization-dropdown",
  docsPdfViewerFooterZoomInIconButton: "common-docs-pdf-viewer-footer-zoom-in-icon-button",
  docsPdfViewerFooterZoomOutIconButton: "common-docs-pdf-viewer-footer-zoom-out-icon-button",
  docsPdfViewerPage: (page: number) => `common-docs-pdf-viewer-page-${page}`,
};

export const testKey = {
  myDocument,
  eSign,
  eConsent,
  common,
};
